<template>
<div class="section">
    <div class="container content-area">
        <div class="content-row content">
            <h2 class="title is-5" v-if="site_data.subtitle">{{site_data.subtitle}}</h2>
            <div :class="['columns', {'is-mobile': !is_mobile}]">
                <div class="column">
                    <div class="inner" v-html="site_data.content"></div>
                    <ContactForm :site_key="site_data.site_key" />
                </div>
                <div class="column" v-html="site_data.content_right"></div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import ContentRow from '../blocks/ContentRow';
import ContactForm from '../blocks/forms/ContactForm';
export default {
    name        :   'ContactPage',
    props       :   ['site_data', 'is_mobile'],
    components  :   { ContentRow, ContactForm }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/ContactPage.vue